import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { insertAdditionalServices } from 'modules/accommodations/features/reservations/api';

export const useMutationInsertAdditionalServices = () => {
  const queryClient = useQueryClient();
  const { errorToast } = useCustomToast();

  const { mutateAsync, isLoading, isError, data } = useMutation(insertAdditionalServices, {
    onSettled: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RESERVATION_INSERT_NEW_ADDITIONAL_SERVICES);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RESERVATION_INSERT_NEW_ADDITIONAL_SERVICES);
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.ErrorDescription;
      errorToast(errorMessage);
    },
  });

  return {
    insertAdditionalServicesMutate: mutateAsync,
    additionalServicesLoading: isLoading,
    additionalServicesError: isError,
    additionalServicesData: data,
  };
};
